import { render, staticRenderFns } from "./RestrictedPermission.html?vue&type=template&id=11d5a484&scoped=true&"
import script from "./RestrictedPermission.js?vue&type=script&lang=js&"
export * from "./RestrictedPermission.js?vue&type=script&lang=js&"
import style0 from "./RestrictedPermission.scss?vue&type=style&index=0&id=11d5a484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d5a484",
  null
  
)

export default component.exports